import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ButtonSet, Button } from '../../models';
import { ButtonService } from '../../services';

@Component({
  selector: 'edit-buttonset-dialog',
  templateUrl: './edit-buttonset-dialog.html',
  styles: ['.mat-form-field { display: block }']
})
export class EditButtonSetDialog implements OnInit {
  firstFormGroup: FormGroup;
  buttonSet: ButtonSet;

  constructor(
    private _fb: FormBuilder,
    public dialogRef: MatDialogRef<EditButtonSetDialog>,
    private buttonService: ButtonService,
    @Inject(MAT_DIALOG_DATA) public data: ButtonSet
  ) {}

  ngOnInit(): void {
    const description = this.data.description ? this.data.description : '';

    this.buttonSet = { ...this.data, description };
    this.firstFormGroup = this._fb.group(this.buttonSet);
  }

  onSaveClick(): void {
    const name = this.firstFormGroup.controls.name.value;
    const description = this.firstFormGroup.controls.description.value;
    const buttonSet = { ...this.buttonSet, name, description };

    this.buttonService.update(buttonSet).subscribe(e => {
      this.dialogRef.close(e);
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
